import React from 'react'
import styled from 'styled-components'
import { colors } from '../styleGuide'

export interface DcTagProps
  extends Omit<React.HTMLProps<HTMLDivElement>, 'ref'> {
  className?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
  textColor?: string
  customBackgroundColor?: string
  variant?: 'default' | 'small'
  children?: React.ReactNode
}

interface StyledDcTagProps {
  textColor: string
  backgroundColor: string
  variant: 'default' | 'small'
}

const StyledDcTag = styled.div<StyledDcTagProps>`
  display: inline-block;
  padding: ${(props) => (props.variant === 'small' ? '2px 6px' : '4px 8px')};
  border-radius: 4px;
  font-size: ${(props) => (props.variant === 'small' ? '10px' : '12px')};
  font-weight: 500;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  border: 1px solid ${colors.grayBorder};
` as any

export const DcTag = React.forwardRef<HTMLDivElement, DcTagProps>(
  (
    {
      className = 'primary',
      customBackgroundColor,
      textColor,
      variant = 'default',
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <StyledDcTag
        textColor={textColor || colors.success}
        backgroundColor={customBackgroundColor || colors.successLight}
        variant={variant}
        className={className}
        ref={ref}
        {...rest}
      >
        {children}
      </StyledDcTag>
    )
  },
)

export default DcTag
